import React, { type FC } from 'react';

import Link from '@atlaskit/link';
import { Text, Pressable, xcss, Flex, Box } from '@atlaskit/primitives';
import LinkExternal from '@atlaskit/icon/utility/link-external';
import ChevronRightIcon from '@atlaskit/icon/utility/chevron-right';

const pressableStyles = xcss({
	':hover': {
		textDecoration: 'underline',
	},
});

type SubtleLinkProps = {
	href?: string;
	onClick?: () => void;
	onClickDisabled?: boolean;
	children?: React.ReactNode;
	analyticsContext?: Record<string, any>;
};

export const SubtleLink: FC<SubtleLinkProps> = ({
	href,
	children,
	onClick,
	onClickDisabled = false,
	analyticsContext,
}) => {
	const linkContent = (
		<Text color="color.text.subtle">
			<Flex alignItems="center" gap="space.150">
				{children}
				{href ? <LinkExternal label="" /> : <ChevronRightIcon label="" />}
			</Flex>
		</Text>
	);

	return href ? (
		<Box padding="space.100">
			<Link appearance="subtle" href={href} analyticsContext={analyticsContext}>
				{linkContent}
			</Link>
		</Box>
	) : (
		<Pressable
			onClick={onClick}
			analyticsContext={analyticsContext}
			padding="space.100"
			backgroundColor="color.background.neutral.subtle"
			xcss={pressableStyles}
			isDisabled={onClickDisabled}
		>
			{linkContent}
		</Pressable>
	);
};
